import * as Yup from 'yup';
import { ValidationError } from 'yup';

export const SpecialSectionSchema = Yup.object()
  .shape({
    title: Yup.string(),
    content: Yup.string(),
  })
  .test({
    name: 'at-least-one-field',
    // eslint-disable-next-line object-shorthand
    test: function (values) {
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      const isValid = !!(values.title || values.content);

      if (isValid) {
        return true;
      }

      const errors = ['title', 'content'].map(
        (fieldName) =>
          new ValidationError(
            'Veuillez saisir au moins un titre ou du contenu.',
            values[fieldName as keyof typeof values],
            fieldName,
          ),
      );

      return this.createError({
        message: () => errors,
      });
    },
  });
